<template>
  <div class="fund-basic">
    <MoreTitle title="基本资料" />
    <div class="row-wrapper">
      <RowInfo label="ETF名称">{{ $digitjs(data.etfName).isNull() }}</RowInfo>
      <RowInfo label="资产净值">
        {{ $digitjs(data.netAssetValue).rounded() }} {{ $digitjs(data.assetsUnderManagementcurrency).isNull() }} (截至
        {{ $digitjs(data.netAssetValueDate).isNull() }})
      </RowInfo>
      <RowInfo label="发行商">{{ $digitjs(data.issuerName).isNull() }}</RowInfo>
      <RowInfo label="追踪指数">{{ $digitjs(data.underlyingIndex).isNull() }}</RowInfo>
      <RowInfo label="基金规模">
        {{ $digitjs(data.assetsUnderManagement).convert() }}
        {{ $digitjs(data.assetsUnderManagementcurrency).isNull() }}
      </RowInfo>
      <RowInfo label="上市时间">{{ $digitjs(data.etfListingDate).isNull() }}</RowInfo>
      <RowInfo label="费用比率">{{ $digitjs(data.ongoingChargesFigure).unit('%').rounded() }}</RowInfo>
      <RowInfo label="派息政策">{{ $digitjs(data.dividendDistribution).isNull() }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  props: ['data']
}
</script>

<style lang="scss" scoped>
.fund-basic {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
}
</style>
